import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver loop limit warnings from react-scripts error overlay
if (typeof window !== "undefined") {
  const resizeObserverError = "ResizeObserver loop completed with undelivered notifications";
  window.addEventListener("error", (e) => {
    if (e.message && e.message.includes(resizeObserverError)) {
      e.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
